import { HTMLProps } from "react";
import FormGroup from "src/components/form/FormGroup";

const LAYOUTS = {
	horizontal:
		"flex flex-col md:items-center md:grid md:grid-cols-[140px,1fr] md:gap-4 gap-1",
	vertical: "flex flex-col gap-2",
};

export interface WrapperProps extends HTMLProps<HTMLDivElement> {
	label?: string;
	layout?: keyof typeof LAYOUTS;
	onFocus?: () => void;
	variant?: "form-group";
}

const Wrapper = ({
	label,
	layout,
	children,
	onFocus,
	variant,
	...rest
}: WrapperProps) => {
	if (variant === "form-group") {
		return (
			<FormGroup noMarginBottom {...{ label }}>
				<div className="flex flex-col flex-1">{children}</div>
			</FormGroup>
		);
	}

	return (
		<div
			className={`${LAYOUTS[label ? layout || "vertical" : "vertical"]}`}
			{...rest}
		>
			{label && (
				<label
					className="font-regular text-placeholder"
					onClick={onFocus}
				>
					{label}
				</label>
			)}
			<div className="flex flex-col flex-1">{children}</div>
		</div>
	);
};

Wrapper.defaultProps = {
	layout: "vertical",
};

export default Wrapper;
